<template>
  <svg class="wave"
     :class="{bottom: bottom}"
     xmlns="http://www.w3.org/2000/svg"
     xmlns:xlink="http://www.w3.org/1999/xlink"
     viewBox="0 24 150 28 "
     preserveAspectRatio="none">

        <defs>
            <path id="gentle-wave"
            d="M-160 44c30 0 
                58-18 88-18s
                58 18 88 18 
                58-18 88-18 
                58 18 88 18
                v44h-352z" />
        </defs>
        <g class="one" v-if="index == 0 || index == 1">
            <use xlink:href="#gentle-wave" x="50" y="0"/>
        </g>
        <g class="two" v-if="index == 0 || index == 2">
            <use xlink:href="#gentle-wave" x="50" y="3"/>
        </g>
        <g class="three" v-if="index == 0 || index == 3">
            <use xlink:href="#gentle-wave" x="50" y="5"/>
        </g>
        <!-- <g class="parallax4">
            <use xlink:href="#gentle-wave" x="50" y="6" fill="#fff"/>  
        </g> -->
    </svg>
</template>

<script>
export default {
    name: "MovingDivider",
    props: {
        index: Number,
        bottom: Boolean
    }
}
</script>

<style lang="scss">
@keyframes move-1 {
  0% {
    transform: translate(85px, 0%);
  }
  100% {
    transform: translate(-90px, 0%);
  }
}

@keyframes move-2 {
  0% {
    transform: translate(70px, 0%);
  }
  100% {
    transform: translate(-85px, 0%);
  }
}

@keyframes move-3 {
  0% {
    transform: translate(90px, 0%);
  }
  100% {
    transform: translate(-95px, 0%);
  }
}

.wave {
    display: block;
    width: 100%;
    height: 10em;
    // max-height: 10em;
    margin: 0;
    z-index: 2;
    pointer-events: none;
    
    position: absolute;
    top: -10em;
    left: 0px;

    &.bottom{
        top: calc(100% - 1px);
        transform: rotate(180deg);
    }

    .one > use {
        fill: var(--light);
        animation: move-1 30s linear infinite;
        &:nth-child(1) {
            animation-delay: -2s;
        }
    }
    .two > use {
        fill: var(--regular);
        animation: move-2 25s linear infinite;
        &:nth-child(1) {
            animation-delay: -2s;
        }
    }
    .three > use {
        fill: var(--medium);
        animation: move-3 20s linear infinite;
        &:nth-child(1) {
            animation-delay: -2s;
        }
    }
}

@media screen and (max-width: 1000px) {
    .wave{
        font-size: 10px;
    }
}

@media screen and (max-width: 768px) {
    .wave {
        height: 4.5rem;
        top: -4.5rem;

        &.bottom {
            top: calc(100% - 1px);
        }
    }
}
</style>